<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		ControlsContainer,
		EnergyDistribution,
		ParameterCardGroupV2,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import { getBatteryIconStatus } from 'src/helpers/virtual_helpers/virtual_icons_helpers';
	import { buildPvTemplateCard } from 'src/helpers/virtual_helpers/template_helpers/virtual_pv_template_helpers';
	//Types
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import type { parameterCardType } from '@Shelly/shelly-design-system/ParameterCardGroup/ParameterCardGroup.types';

	export let statuses: VCInterfaceStatus[];

	let pvData: ReturnType<typeof buildPvTemplateCard> = null;
	let sectionParameters: parameterCardType[] = [];
	let energyDistCardsLength: number = 0;

	$: if (statuses) {
		pvData = buildPvTemplateCard(statuses);
		energyDistCardsLength = pvData.cards?.length || 0;
		sectionParameters = [
			pvData?.batteryStatus != null && {
				title: pvData.batteryStatus || '--',
				icon: pvData.batteryStatusIcon || 'fas fa-battery-bolt',
				description: $format('text_battery_state', { default: 'Battery State' }),
			},
			pvData?.batteryLevel != null && {
				title: `${pvData.batteryLevel} %`,
				icon: getBatteryIconStatus(pvData.batteryLevel).icon,
				iconColor: getBatteryIconStatus(pvData.batteryLevel)
					.iconColor as parameterCardType['iconColor'],
				description: $format('icon_name_battery', { default: 'Battery' }),
			},
		].filter(Boolean);
	}
</script>

<div class="flex-full-height" color="color-0">
	{#if sectionParameters?.length > 0}
		<ParameterCardGroupV2 class="mb-s" {sectionParameters} />
	{/if}
	{#if pvData}
		<ControlsContainer orientation="vertical" color="color-0">
			<div slot="first" style="pointer-events:none">
				{#key energyDistCardsLength}
					<EnergyDistribution
						id="template-energy-distribution"
						cards={pvData.cards}
						paths={pvData.paths}
					/>
				{/key}
			</div>
		</ControlsContainer>
	{/if}
</div>
